module.exports = __webpack_public_path__ + "e9fcddbf9e125bcc9e0882e9ec60e216.png";